import { render } from "./NewCampaign.vue?vue&type=template&id=4b8f8b98&scoped=true"
import script from "./NewCampaign.vue?vue&type=script&lang=js"
export * from "./NewCampaign.vue?vue&type=script&lang=js"

import "./NewCampaign.vue?vue&type=style&index=0&id=4b8f8b98&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b8f8b98"]])

export default __exports__